import styled from 'styled-components'
import { IMaskInput } from 'react-imask'

interface IStyleProps {
  rounded?: boolean
  small?: boolean
  xsmall?: boolean
  large?: boolean
  icon?: boolean
  error?: string
  marginRight?: number
  smallPad?: boolean
  disabled?: boolean
  resumeCard?: boolean
}

export const MaskedInput = styled(IMaskInput)`
  position: ${(props: IStyleProps) => (props.icon ? 'relative' : 'inherit')};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-right: ${(props: IStyleProps) => {
    if (props.marginRight) return `${props.marginRight}px`
    return '0'
  }};
  height: 50px;
  width: ${(props: IStyleProps) => {
    if (props.xsmall) return '139px'
    if (props.small) return '150px'
    if (props.large) return '200px'
    return '315px'
  }};
  max-width: ${(props: IStyleProps) => {
    if (props.xsmall) return '139px'
    if (props.small) return '150px'
    if (props.large) return '200px'
    return '315px'
  }};
  padding: ${(props: IStyleProps) => {
    if (props.smallPad) return '20px 10px'
    if (props.resumeCard) return '0'
    return '20px 50px 20px 20px'
  }};
  &:hover {
    background: ${(props: IStyleProps) =>
      props.error ? '#F6066510' : '#8f888133'};
  }
  box-sizing: border-box;
  border: ${(props: IStyleProps) =>
    props.error ? '1px solid #E41D1D !important' : '1px solid #9c948c'};
  border-radius: ${(props: IStyleProps) => (props.rounded ? '30px' : '5px')};
  background: ${(props: IStyleProps) =>
    props.error ? '#F606650D !important' : '#f9f9f9'};

  &:disabled {
    &::placeholder {
      color: ${(props: IStyleProps) => {
        if (props.error) return '#E41D1D'
        return '#757575'
      }};
    }
    color: ${(props: IStyleProps) => {
        if (props.error) return '#E41D1D'
        return 'hsl(0, 0%, 20%)'
      }};
      /* opacity: 0.5; */
      background: lightGray;
    border: 0;
    
  }

`

export const InputIcon = styled.img`
  width: ${(props: { icon: string }) => {
    if (props.icon === 'password') return '16px'
    return '20px'
  }};

  height: ${(props: { icon: string }) => {
    if (props.icon === 'password') return '16px'
    return '20px'
  }};

  filter: invert(48%) sepia(5%) saturate(92%) hue-rotate(98deg) brightness(93%)
    contrast(97%);

  position: absolute;
  right: 25px;
  top: 17px;
`

export const InputError = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: start;
  padding: 5px 20px;
  width: 215px;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #f60665;
`
